import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireGuest } from '@/lib/auth-guard'

export const Route = createFileRoute('/_auth')({
  beforeLoad: async () => {
    await requireGuest()
  },
  component: AuthLayout,
})

function AuthLayout() {
    return <Outlet />
}

